// Three-tab sub-navigation shown on every Directory page.

import { NavLink } from 'react-router-dom';

export default function DirectoryTopNav() {
  return (
    <nav className="directory-tabs" aria-label="Directory tabs">
      <NavLink to="/sales/directory" end className={({ isActive }) => 'directory-tab' + (isActive ? ' directory-tab--active' : '')}>
        Search
      </NavLink>
      <NavLink to="/sales/directory/companies" className={({ isActive }) => 'directory-tab' + (isActive ? ' directory-tab--active' : '')}>
        By Management Co.
      </NavLink>
      <NavLink to="/sales/directory/opportunities" className={({ isActive }) => 'directory-tab' + (isActive ? ' directory-tab--active' : '')}>
        Opportunities
      </NavLink>
    </nav>
  );
}
